export function normalizeCnpj(cnpj) {
  return cnpj?.replace(/[^0-9A-Za-z]+/gi, '').toUpperCase();
}

export function normalizeCpf(cpf) {
  return cpf?.replace(/[^0-9]+/g, '');
}

export function formatCnpj(cnpj) {
  const normalized = normalizeCnpj(cnpj);

  if (!normalized || normalized.length !== 14) return normalized || '';

  return normalized.replace(
    /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/,
    '$1.$2.$3/$4-$5'
  );
}

export function formatCpf(cpf) {
  const normalized = normalizeCpf(cpf);

  if (!normalized || normalized.length !== 11) return normalized || '';

  return normalized.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function checkCnpj(input) {
  const charToValue = char => {
    const code = char.charCodeAt(0);
    // Regra do CNPJ alfanumérico: valor = ASCII - 48
    // '0'..'9' => 0..9 | 'A'..'Z' => 17..42
    return code - 48;
  };

  const calcDigit = base => {
    let sum = 0;
    let weight = 2;
    for (let i = base.length - 1; i >= 0; i--) {
      sum += charToValue(base[i]) * weight;
      weight = weight === 9 ? 2 : weight + 1;
    }
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const cnpj = normalizeCnpj(input);
  if (!cnpj || cnpj.length !== 14) return false;

  if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false;
  if (/^([A-Z0-9])\1{13}$/.test(cnpj)) return false;

  const d1 = calcDigit(cnpj.slice(0, 12));
  if (d1 !== Number(cnpj[12])) return false;

  const d2 = calcDigit(cnpj.slice(0, 12) + d1);
  return d2 === Number(cnpj[13]);
}

export function checkCpf(input) {
  const cpf = normalizeCpf(input);

  if (!cpf || cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
    return false;
  }

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += Number(cpf[i]) * (10 - i);
  }

  let checkDigit = (sum * 10) % 11;
  if (checkDigit === 10) checkDigit = 0;
  if (checkDigit !== Number(cpf[9])) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += Number(cpf[i]) * (11 - i);
  }

  checkDigit = (sum * 10) % 11;
  if (checkDigit === 10) checkDigit = 0;
  return checkDigit === Number(cpf[10]);
}
